export enum MessageNotificationType {
    TextEMail = 1,
    HtmlEMail = 2,
    SMS = 3,
    Pager = 4,
    IM = 5
}

export enum FormType {
    Application = 1,
    Request = 2,
    ServiceChangeRequest = 3,
    CanccelationService = 4,
    NewTransfer = 5,
    PendingApplication = 6,
    VerifiedUser = 7,
  }
